<template>
    <div class="input-group-append">
        <span
            v-if="type === 'text' && value !== undefined"
            :id="id + '-tooltip'"
            class="input-group-text"
            :class="postpendClass || 'bg-light'"
        >
                {{ value }}%
        </span>
        <div v-else-if="type == 'bizgraph-mark'" class="input-group-text">
            <img class="" :id="id + '-tooltip'" src="/assets/img/logo@2x.png" width="18">
        </div>
        <div v-else-if="type === 'warning'" class="input-group-text">
            <i class="fal fa-exclamation-triangle" :id="id + '-tooltip'"></i>
        </div>
        <div v-else-if="type === 'loading'" class="input-group-text position-relative">
            <span class="loader small"></span>
        </div>
        <span v-else class="input-group-text"></span>
        <b-popover v-if="tooltip" :target="id + '-tooltip'" placement="top" triggers="hover">
            <span class="small">{{ tooltip }}</span>
        </b-popover>
    </div>
</template>

<script>
    export default {
        name: 'postpend',
        props: {
            postpendClass: {type: String, default: ''},
            value: {default: undefined},
            id: {type: String, required: true},
            tooltip: {type: String},
            type: {type: String}
        },
    };
</script>
